import { Endpoints } from './EndPoints';

const baseUrl = process.env.REACT_APP_BASE_URL;
const version = process.env.REACT_APP_VERSION;

export const APIConstant = {
    getClientGroupList: `${baseUrl}${version}${Endpoints.clientGroupList}`,
    getSymbolList: `${baseUrl}${version}${Endpoints.symbolList}`,
    refreshSymbolList: `${baseUrl}${version}${Endpoints.refreshSymbolList}`,
    getSymbolGroupList: `${baseUrl}${version}${Endpoints.symbolGroupList}`,
    filterSymbolList: `${baseUrl}${version}${Endpoints.filterSymbolList}`,
    POSTLiveTrade: `${baseUrl}${version}${Endpoints.saveTrading}`,
    getliveTradeList: `${baseUrl}${version}${Endpoints.liveTradeList}`,
    createOrUpdateClientGroup: `${baseUrl}${version}${Endpoints.createOrUpdateClientGroup}`,
    createOrUpdateSymbolGroup: `${baseUrl}${version}${Endpoints.createOrUpdateSymbolGroup}`,
    runCprScan: `${baseUrl}${version}${Endpoints.runCprScan}`,
    getCprCandles: `${baseUrl}${version}${Endpoints.getCprCandles}`,
    getApiMetrics: `${baseUrl}${version}${Endpoints.getApiMetrics}`,
}